module.exports = __webpack_public_path__ + "img/battery2.8c43f06d.png";